import {
  CRUD_CAMPAIGN_ACTIVITY,
  GET_CAMPAIGN_ACTIVITY_BY_CAMPAIGN_ID,
  CRUD_INQUIRY_ACTIVITY,
  GET_INQUIRY_ACTIVITY_BY_INQUIRY_ID,
  CRUD_LEAD_ACTIVITY,
  GET_LEAD_ACTIVITY_BY_LEAD_ID,
  CRUD_PROSPECT_ACTIVITY,
  GET_PROSPECT_ACTIVITY_BY_PROSPECT_ID,
  CRUD_OPPORTUNITY_ACTIVITY,
  GET_OPPORTUNITY_ACTIVITY_BY_OPPORTUNITY_ID,
  CRUD_CONTACT_ACTIVITY,
  GET_CONTACT_ACTIVITY_BY_CONTACT_ID,
  CRUD_ACCOUNT_ACTIVITY,
  GET_ACCOUNT_ACTIVITY_BY_ACCOUNT_ID,
  CRUD_CUSTOMER_ACTIVITY,
  GET_CUSTOMER_ACTIVITY_BY_CUSTOMER_ID,
  CRUD_CONTRACT_ACTIVITY,
  GET_CONTRACT_ACTIVITY_BY_CONTRACT_ID,
  CRUD_ORDER_ACTIVITY,
  GET_ORDER_ACTIVITY_BY_ORDER_ID,
  CRUD_ACTIVITY,
} from "@routes";

// Route maps based on entity type for Activity sourced directly from @routes
export const ACTIVITY_ROUTES = {
  lead: {
    base: CRUD_LEAD_ACTIVITY,
    fetchById: `${CRUD_LEAD_ACTIVITY}/fetch-by-id`,
    byEntityId: GET_LEAD_ACTIVITY_BY_LEAD_ID,
    idKey: "leadId",
  },
  prospect: {
    base: CRUD_PROSPECT_ACTIVITY,
    fetchById: `${CRUD_PROSPECT_ACTIVITY}/fetch-by-id`,
    byEntityId: GET_PROSPECT_ACTIVITY_BY_PROSPECT_ID,
    idKey: "prospectId",
  },
  campaign: {
    base: CRUD_CAMPAIGN_ACTIVITY,
    fetchById: `${CRUD_CAMPAIGN_ACTIVITY}/fetch-by-id`,
    byEntityId: GET_CAMPAIGN_ACTIVITY_BY_CAMPAIGN_ID,
    idKey: "campaignId",
  },
  opportunity: {
    base: CRUD_OPPORTUNITY_ACTIVITY,
    fetchById: `${CRUD_OPPORTUNITY_ACTIVITY}/fetch-by-id`,
    byEntityId: GET_OPPORTUNITY_ACTIVITY_BY_OPPORTUNITY_ID,
    idKey: "opportunityId",
  },
  inquiry: {
    base: CRUD_INQUIRY_ACTIVITY,
    fetchById: `${CRUD_INQUIRY_ACTIVITY}/fetch-by-id`,
    byEntityId: GET_INQUIRY_ACTIVITY_BY_INQUIRY_ID,
    idKey: "inquiryId",
  },
  "customer-account": {
    base: CRUD_ACCOUNT_ACTIVITY,
    fetchById: `${CRUD_ACCOUNT_ACTIVITY}/fetch-by-id`,
    byEntityId: GET_ACCOUNT_ACTIVITY_BY_ACCOUNT_ID,
    idKey: "customerAccountId",
  },
  account: {
    base: CRUD_ACCOUNT_ACTIVITY,
    fetchById: `${CRUD_ACCOUNT_ACTIVITY}/fetch-by-id`,
    byEntityId: GET_ACCOUNT_ACTIVITY_BY_ACCOUNT_ID,
    idKey: "customerAccountId",
  },
  contact: {
    base: CRUD_CONTACT_ACTIVITY,
    fetchById: `${CRUD_CONTACT_ACTIVITY}/fetch-by-id`,
    byEntityId: GET_CONTACT_ACTIVITY_BY_CONTACT_ID,
    idKey: "contactId",
  },
  customer: {
    base: CRUD_CUSTOMER_ACTIVITY,
    fetchById: `${CRUD_CUSTOMER_ACTIVITY}/fetch-by-id`,
    byEntityId: GET_CUSTOMER_ACTIVITY_BY_CUSTOMER_ID,
    idKey: "customerId",
  },
  contract: {
    base: CRUD_CONTRACT_ACTIVITY,
    fetchById: `${CRUD_CONTRACT_ACTIVITY}/fetch-by-id`,
    byEntityId: GET_CONTRACT_ACTIVITY_BY_CONTRACT_ID,
    idKey: "contractId",
  },
  order: {
    base: CRUD_ORDER_ACTIVITY,
    fetchById: `${CRUD_ORDER_ACTIVITY}/fetch-by-id`,
    byEntityId: GET_ORDER_ACTIVITY_BY_ORDER_ID,
    idKey: "orderId",
  },
};

// Default fallback routes
export const DEFAULT_ACTIVITY_ROUTES = {
  base: CRUD_ACTIVITY,
  fetchById: `${CRUD_ACTIVITY}/fetch-by-id`,
};

const ACCOUNT_TYPE_ALIASES = new Set([
  "customeraccount",
  "customer-account",
  "account",
]);

const ACTIVITY_ENTITY_RULES = [
  { type: "contract", keys: ["contractId", "forContract"] },
  {
    type: "customer-account",
    keys: ["customerAccountId", "accountId", "forAccount"],
  },
  { type: "contact", keys: ["contactId", "forContact"] },
  { type: "opportunity", keys: ["opportunityId", "forOpportunity"] },
  { type: "lead", keys: ["leadId", "forLead"] },
  { type: "campaign", keys: ["campaignId", "forCampaign"] },
  { type: "inquiry", keys: ["inquiryId", "forInquiry"] },
  { type: "prospect", keys: ["prospectId", "forProspect"] },
  { type: "customer", keys: ["customerId", "forCustomer"] },
  { type: "order", keys: ["orderId", "forOrder"] },
];

export const normalizeActivityType = (type) => {
  if (!type || typeof type !== "string") {
    return null;
  }
  const cleanType = type.toLowerCase().trim();
  if (ACCOUNT_TYPE_ALIASES.has(cleanType)) {
    return "customer-account";
  }
  return cleanType;
};

export const resolveActivityEntityType = (data) => {
  if (!data || typeof data !== "object") {
    return null;
  }

  const explicitType =
    data?.entityType ||
    data?.targetEntity ||
    data?.type ||
    data?.entity;

  const normalized = normalizeActivityType(explicitType);
  if (normalized && ACTIVITY_ROUTES[normalized]) {
    return normalized;
  }

  for (const rule of ACTIVITY_ENTITY_RULES) {
    for (const key of rule.keys) {
      if (data[key] !== undefined && data[key] !== null) {
        return rule.type;
      }
    }
  }

  return null;
};

export const getActivityRoutesByType = (type) => {
  const normalizedType = normalizeActivityType(type);
  if (normalizedType && ACTIVITY_ROUTES[normalizedType]) {
    return ACTIVITY_ROUTES[normalizedType];
  }
  return DEFAULT_ACTIVITY_ROUTES;
};

export const getActivityRouteByType = (type, actionType = "base") => {
  const routes = getActivityRoutesByType(type);
  switch (actionType) {
    case "getActivity":
      return routes?.byEntityId || routes?.base;
    case "addActivity":
    case "updateActivity":
    case "deleteActivity":
    default:
      return routes?.base;
  }
};

export const getActivityRoute = (data, actionType = "base") => {
  const resolvedType = resolveActivityEntityType(data);
  return getActivityRouteByType(resolvedType, actionType);
};
